// [APP-FORK] 앱(WebView) 점주 검증 QR 통합 진입 페이지.
// 네이티브가 naegift://verify/{uuid} 스캔 → 웹뷰로 /app/qr/verify/{uuid} 로드 →
// 이 페이지가 역매핑 EP(@Public)를 호출해 기존 검증 라우트로 replace navigate 한다.
//   verify: GET {API_SERVER_PUBLIC}app/qr/verify/{uuid}
//           → {resultCode,...,data:{storeNo,userGiftNo,giftNo}} (전역 인터셉터 래핑 → res.data.data 언랩)
//           → /mobile/verifyconfirm/{storeNo}/{userGiftNo}/{giftNo}
//             (기존 VerifyConfirm 이 검증 EP 호출 + 성공/실패/403/409/로그인 전부 처리 = 설계 A)
// ★store/gift 는 user-app 소관 — 이 admin 페이지는 verify 만 담당.
// 실패(404/네트워크/미지원 type)는 기존 /mobile/verifyinvalid 로 위임(로그인/storeNo 처리 재사용).
import { useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';

import LazySpinner from '../admin/LazySpinner';

export default function AppQrEntry() {
  const navigate = useNavigate();
  const { type, uuid } = useParams();
  // StrictMode 이중 실행 가드 + 단일 처리 보장
  const startedRef = useRef(false);

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;

    const publicBase = process.env.REACT_APP_API_SERVER_PUBLIC;

    const resolve = async () => {
      // 이 admin 진입 페이지는 verify 만 담당(store/gift 는 user-app 소관)
      if (!uuid || type !== 'verify') {
        navigate('/mobile/verifyinvalid', { replace: true });
        return;
      }

      try {
        const res = await axios.get(`${publicBase}app/qr/verify/${uuid}`, {
          withCredentials: true,
        });
        // 전역 인터셉터 래핑: {resultCode,...,data:{...}} → data 언랩
        const { storeNo, userGiftNo, giftNo } = res?.data?.data ?? {};
        if (
          storeNo == null ||
          userGiftNo == null ||
          giftNo == null
        ) {
          navigate('/mobile/verifyinvalid', { replace: true });
          return;
        }
        // 기존 검증 라우트로 위임(검증 실행·결과화면·인증은 VerifyConfirm 담당)
        navigate(
          `/mobile/verifyconfirm/${storeNo}/${userGiftNo}/${giftNo}`,
          { replace: true }
        );
      } catch (error) {
        // 404(만료/오매핑) 등 → 기존 invalid 처리로 위임
        console.error('[app-qr] verify resolve failed:', error);
        navigate('/mobile/verifyinvalid', { replace: true });
      }
    };

    resolve();
  }, [type, uuid, navigate]);

  return <LazySpinner />;
}
